<template>
  <BaseLayout>
    <div
      class="md:flex-row relative backgroundImage py-6 md:p-0 flex flex-col justify-center min-h-screen"
    >
      <div
        class="md:w-5/12 w-11/12 bg-white opacity md:opacity-100 rounded-md md:rounded-sm xl:h-screen xl:flex xl:flex-col p-5 sm:p-10 mx-auto"
      >
        <div class="mb-8 mt-4 max-w-sm mx-auto w-full">
          <router-link :to="{ name: 'DashboardBeforeLogin' }">
            <img
              :src="require(`@/assets/img/fitclas.png`)"
              alt=""
              class="w-32 object-cover"
            />
          </router-link>
        </div>
        <div
          class="h-full flex items-center"
        >
          <div class="max-w-sm mx-auto flex-1">
            <h3 class="text-3xl font-semibold leading-8">
              Reset your password
            </h3>
            <p class="text-sm pt-1.5">Dont worry let's get you back in.</p>
            <form class="mt-8 xl:w-95" @submit.prevent="handleReset">
              <div class="mt-4">
                <FormInput
                  :type="'text'"
                  v-model="$v.email.$model"
                  :classStr="{ 'border-red-500': $v.email.$error }"
                  >Enter Email</FormInput
                >
                <div v-if="$v.email.$error">
                  <small class="text-red-500" v-if="!$v.email.required">
                    Email field is required.
                  </small>
                  <small class="text-red-500" v-if="!$v.email.email">
                    Accepts valid email addresses.
                  </small>
                </div>
              </div>

              <div class="mt-4">
                <Button classStr="hover:bg-green-dark"> Email me the recovery link </Button>
              </div>
              <div class="flex items-center text-xs 3xl:text-lg mt-4">
                <p class="font-semibold text-xs">Have an account?</p>
                <router-link :to="{ name: 'Login' }" class="ml-1 hover:underline text-green-light font-semibold">
                  Log in
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="hidden md:inline md:w-7/12">
        <img
          class="object-cover md:object-cover h-screen w-full"
          :src="require(`@/assets/img/login.webp`)"
          alt="..."
        />
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/components/layouts/BaseLayout";
import { FormInput, Button } from "@/components/t-components";
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "ResetPassword",
  components: {
    BaseLayout,
    FormInput,
    Button,
  },
  data() {
    return {
      email: null,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    ...mapActions(["resetPassword"]),

    handleReset() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const data = {
          email: this.email,
        };
        this.resetPassword(data);
      }
    },
  },
};
</script>
<style scoped>
@media only screen and (max-width: 767px) {
  .backgroundImage {
    background-image: url("../assets/img/login.webp");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .opacity {
    opacity: 0.9;
  }
}
</style>